import { useState } from 'react'

import CustomSplitter from '../../../components/splitter/splitter'
import GenericTabs from '../../../components/tabs/tabs'
import DropDown from '../../../components/drop-down/drop-down'

import ChatGpt from './by-model/chat-gpt'
import Cluade from './by-model/cluade'
import Gemini from './by-model/gemini'

import Abbreviation from './by-field/abbreviation'

const AnalysisSet = () => {

  return (
    <div className='analysis-set-con'>
         <CustomSplitter orientation="vertical"  style = { { width:"100%" , height:"calc(100vh - 100px)"  , padding:"0px" , margin:"0px"}}>
              <Document/>
              <Bottom/>
         </CustomSplitter>
    </div>
  )
}

const Bottom = ( )=>{

    const byModelTabs = [
        { id: "tab1", title: "Chat Gpt 5.2", content:<ChatGpt/> },
        { id: "tab2", title: "Claude Opus 4.6", content:<Cluade/> },
        { id: "tab3", title: "Gemini 3 Pro", content:<Gemini/> },
    ]

    const dropDownOptions = [ 
      {
        id:1,
        title:"By Model",
        value:"Model"
      },
      {
        id:2,
        title:"By Field",
        value:"Field"
      },
    ]

    const [ selOption , setSelOption ] = useState(dropDownOptions[1])

    const handleTabChange = (tab, idx) => {
    console.log("Selected tab:", tab, "Index:", idx);
  };

      const byFieldTabs = [
        { id: "tab1", title: "Abbreviation", content:<Abbreviation/> },
        { id: "tab2", title: "Description", content:<span>Description</span> },
        { id: "tab3", title: "Treatment", content:<span>Treatment</span> },
        { id: "tab4", title: "Usage", content:<span>Usage</span> },
    ]

    return(
        <div style={{height:"100%"}}>
            <div style={{margin:"5px"}}>
              <DropDown
              options={dropDownOptions}
              value={selOption}
              onChange={setSelOption}
              triggerStyle = {{
                width:"150px",
                height:"25px"
              }}
              menuStyle = { 
                {
                  width:"150px",
                  top:"35px"
                }
              }
           />
            </div>
            <GenericTabs
              tabs={ selOption?.value == "Model" ? byModelTabs : byFieldTabs }
              onTabChange={handleTabChange}
              closable={false}
              style = { { width:"100%" , height:"100%" } }
            />
        </div>
    )
}


const styles = {
  container: {
    // maxWidth: "900px",
    // margin: "10px auto",
    padding: "10px",
    backgroundColor: "#ffffff",
    // borderRadius: "12px",
    // boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    // fontFamily: "Segoe UI, Roboto, sans-serif",
    lineHeight: "1.7",
    color: "#2c3e50"
  },
  sectionTitle: {
    fontSize: "22px",
    fontWeight: "600",
    marginBottom: "20px",
    borderBottom: "2px solid #e5e7eb",
    paddingBottom: "8px",
    letterSpacing: "0.5px"
  },
  subTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginTop: "25px",
    marginBottom: "12px",
    color: "#34495e"
  },
  paragraph: {
    fontSize: "15px",
    textAlign: "justify",
    color: "#4b5563"
  }
};

const Document = () => {
  return (
    <div style={styles.container}>
      <h3 style={styles.sectionTitle}>7. ANALYSIS POPULATIONS</h3>

      <h4 style={styles.subTitle}>7.1. Safety Population</h4>

      <p style={styles.paragraph}>
        All subjects receiving FPV or FPV/RTV at any dose will be included in
        the safety population. Safety events will be summarized in two groups:
        those reported cumulatively throughout the study and those reported
        after 05July2011 until study completion (EoS). The EoS population
        continuing in the study following the July 5 2011 cut-off date will be
        the primary population for any safety analyses in this amended RAP and
        all cumulative safety events will be listed for this study.
      </p>
    </div>
  );
};


export default AnalysisSet